import { FC } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Heading } from 'src/components/heading';
import { ExternalLink, Link } from 'src/components/link';
import { ThrowNotFound } from 'src/components/not-found';
import { Stack } from 'src/components/stack';
import { Spacer } from 'src/pages/settings/registration/components/form-utils';
import DirectFcfs from 'src/pages/transport/fcfs-booking/direct';
import { FCFSBookingWizard } from 'src/pages/transport/fcfs-booking/regular';

export const FcfsBooking: FC = () => {
  return (
    <Stack gap={1}>
      <Heading mode="title">New Booking</Heading>

      {PRISMA_CONFIG.directFcfs ? (
        <div>
          <Stack flow="column" gap={2.5} inline>
            <ExternalLink
              mode="pill"
              href={`${PRISMA_CONFIG.oldFrontendUrl}/#/fcfs-booking`}
            >
              Regular FCFS
            </ExternalLink>

            <Link to={`/transport/fcfs-booking/direct`} mode="pill">
              Direct FCFS
            </Link>
          </Stack>
        </div>
      ) : null}

      <Spacer />

      <Switch>
        <Route path="/transport/fcfs-booking" exact>
          <Redirect to="/transport/fcfs-booking/regular" />
        </Route>

        <Route path="/transport/fcfs-booking/regular">
          <FCFSBookingWizard />
        </Route>

        <Route path="/transport/fcfs-booking/direct">
          <DirectFcfs />
        </Route>

        <Route>
          <ThrowNotFound />
        </Route>
      </Switch>
    </Stack>
  );
};
